<template>
    <div class="smooth-list">
        <div class="list-header">
            <input type="text" class="form-control" :placeholder="`${$lang.get('trans.search')}...`" v-model="searchTerm">
        </div>
        
        <div class="variable-list container-fluid">            
            <div class='row variable-group' v-for="(vars, groupName) in filteredVariables" :key='groupName'>            
                
                <h4 class='col-md-12'>{{ groupName | titleCase }}</h4>
                <variable-list-item
                        v-for="(name, slug) in vars"
                        :key="slug"
                        :name="name"
                        :slug="slug"
                        :path="[groupName]"
                        :collection-path="[]"
                        @insert="$emit('insert', $event)"
                >
                </variable-list-item>

            </div>
            
        </div>

    </div>
</template>

<script>
    import VariableListItem from './VariableListItem'

    export default {
        name: "variable-list",

        components: {
            VariableListItem
        },

        props: {
            variables: {
                required: true
            }
        },

        data() {
            return {
                searchTerm: null
            }
        },

        computed: {
            filteredVariables() {
                if (!this.searchTerm) {
                    return this.variables;
                }

                let searchTerm = _.toLower(this.searchTerm);
                let results = {};

                _.each(this.variables, (name, slug) => {
                    let res = filterTerms(name, slug);

                    if (! _.isEmpty(res)) {
                        results[slug] = res;
                    }
                });

                function filterTerms(name, slug) {
                    let results = {};

                    if (_.isString(name)) {
                        if (_.includes(_.toLower(name), searchTerm) || _.includes(_.toLower(slug), searchTerm)) {
                            return name;
                        }
                    } else {
                        _.each(name, (sub_name, sub_slug) => {
                            let sub_result = filterTerms(sub_name, sub_slug);

                            if (! _.isEmpty(sub_result)) {
                                results[sub_slug] = sub_result;
                            }
                        });
                    }

                    return results;
                }

                return results;
            }
        }
    }
</script>
